module.exports = __webpack_public_path__ + "img/vbf.75247114.svg";